import { Script } from "./script";
const gatewayScript = (gGubKeyHash, gHash) => new Script()
    .addData(gHash)
    .addOp(Script.OP.OP_DROP)
    .addOp(Script.OP.OP_DUP)
    .addOp(Script.OP.OP_HASH160)
    .addData(gGubKeyHash)
    .addOp(Script.OP.OP_EQUALVERIFY)
    .addOp(Script.OP.OP_CHECKSIG);
export const createAddress = (gGubKeyHash, gHash, prefix) => gatewayScript(gGubKeyHash, gHash).toAddress(prefix);
export const pubKeyScript = (gGubKeyHash, gHash) => gatewayScript(gGubKeyHash, gHash).toScriptHashOut();
//# sourceMappingURL=v2.js.map